import {
  SET_ROLES_LIST,
  SET_JOB_DETAILS,
  UPDATE_SINGLE_ROLE_DATA,
  SET_JOB_ID,
  SET_CITIES,
  SET_ABOUT_US,
  SET_PAGE_NUM,
} from 'modules/Roles/actions'

const initialState = {
  rolesList: [],
  singleRoleDetails: {},
  jobId: '',
  roleData: {
    singleRoleData: {
      RoleType: 'Full Time',
      peopleCount: '1000-1200',
      applyBefore: '05 Jun 2022',
      description:
        ' We are hiring for a digital marketing agencysDescriptionPecializes in SEO,SMM,SEM, website design and development,content writing,app design and development along with providing virtual receptionistserivices ',
    },
    jobLocation: {
      cities: ['Bengaluru', 'Channai', 'Mumbai'],
      remotCities: ['AnyWhere'],
    },
    elgibilty: {
      degrees: [
        {
          branch: 'BE , B.Tech',
        },
      ],
      isArrearsAllowed: false,
      arrearCount: {
        count: 4,
      },

      skills: [
        'React Js',
        'Java',
        'JavaScript',
        'HTML',
        'Node Js',
        'Machine Learning',
        'Python',
        'CSS',
        'Custome Experience',
        'Artificial Intligence',
      ],
      yearOfPassing: ['2021', '2022'],
      scores: {
        avg: 60,
        tenth: 60,
        twelfth: 60,
        UG: 60,
        PG: 60,
      },
    },
    interviewWorkFlow: {
      rounds: ['Apptitude Test', 'Technical test'],
      roundDetails: {
        apptTest:
          ' This test will have 80 questions.There is no negative marking',
        TechTest:
          'This test will have 15 questions.There is no negative marking',
      },
    },
    aboutUsDetails: {
      companyDetails: {
        techno: 'Technology',
        emp: '1,00,000-1,20,000',
        since: '1994',
      },
      descriptions: {
        aboutCompany:
          'Our platform helps the stakeholders to research efficiently with the most advanced search engine developed through cutting-edge technology as we have transformed complex data into a user-friendly form to help users to search and research faster. We believe in providing access to the vast and comprehensive legal data to our users on the most reliable,accurate,valuable and speed manner. We want to make Legit Quest as a one-stop solution for its users with the help of various supporting features..',
        videoLink: 'www.youtube.com',
      },
      connectUrl: {
        urlLink: 'www.infosys.com',
      },
      companyLocation: {
        cities: ['Bengaluru', 'Channai', 'Mumbai'],
      },
      otherDetails: {
        companyType: 'Technology',
        established: '1994',
        skills: [
          'React Js',
          'Java',
          'JavaScript',
          'HTML',
          'Node Js',
          'Machine Learning',
          'Python',
          'CSS',
          'Custome Experience',
          'Artificial Intligence',
        ],
      },
    },
  },
  cities: [],
  corporateDetails: {},
  pageNum: 0,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ROLES_LIST:
      return {
        ...state,
        rolesList: action.data,
      }
    case SET_JOB_DETAILS:
      return {
        ...state,
        singleRoleDetails: action.data,
      }
    case UPDATE_SINGLE_ROLE_DATA:
      return {
        ...state,
        roleData: action.data,
      }
    case SET_JOB_ID:
      return {
        ...state,
        jobId: action.id,
      }
    case SET_CITIES:
      return {
        ...state,
        cities: action.data,
      }
    case SET_ABOUT_US:
      return {
        ...state,
        corporateDetails: action.data,
      }
    case SET_PAGE_NUM:
      return {
        ...state,
        pageNum: action.data,
      }
    default:
      return state
  }
}
